// extracted by mini-css-extract-plugin
module.exports = {"faq":"FAQ_faq__ep4Vo","none":"FAQ_none__oc_EZ"};